module.exports = __webpack_public_path__ + "static/media/mid.ad36bec5.jpg";